// Small date helpers — kept inline so cards & strips can show
// "2 days ago" style stamps and recency badges without pulling in
// a heavier library.

export function relativeTime(iso?: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 45) return "just now";
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;
  if (day < 30) {
    const w = Math.round(day / 7);
    return `${w}w ago`;
  }
  if (day < 365) {
    const mo = Math.round(day / 30);
    return `${mo}mo ago`;
  }
  const yr = Math.round(day / 365);
  return `${yr}y ago`;
}

export function daysSince(iso?: string): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
}

/** Was this item created in the last N days? Default 14. */
export function isNew(createdIso?: string, withinDays = 14): boolean {
  const d = daysSince(createdIso);
  return d != null && d <= withinDays;
}

/**
 * Was the item modified recently — but NOT just a "new" item?
 * We only want to flag "Updated" when the modify date is meaningfully
 * after the create date (so freshly created items don't get both badges).
 */
export function isRecentlyUpdated(
  createdIso?: string,
  modifiedIso?: string,
  withinDays = 14
): boolean {
  if (!modifiedIso) return false;
  const m = daysSince(modifiedIso);
  if (m == null || m > withinDays) return false;
  if (!createdIso) return true;
  const c = new Date(createdIso).getTime();
  const mod = new Date(modifiedIso).getTime();
  if (Number.isNaN(c) || Number.isNaN(mod)) return false;
  // Require >2 days delta between create and modify to count as "updated"
  return mod - c > 2 * 24 * 60 * 60 * 1000;
}
